/* eslint-disable react/no-unescaped-entities */
import dotenv from 'dotenv'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'

dotenv.config()

const useStyles = makeStyles(() =>
  createStyles({
    info: {
      marginBottom: '12px'
    }
  })
)

export default function Info (): JSX.Element {
  const classes = useStyles()
  if (!process.env.REACT_APP_INFO_MESSAGE) return <></>

  return (
    <Grid className={classes.info}>
      <MuiAlert elevation={2} variant="filled" severity='info'>{process.env.REACT_APP_INFO_MESSAGE}</MuiAlert>
    </Grid>
  )
}
